import React from "react";
import gif from "../images/gif.gif";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="error-container">
      <img src={gif} alt="" className="img-error" />
      <h1>Opps :( Page not found!</h1>
      <div className="btn-center-cart">
        <button>
          <Link to="/" className="Link-cart" style={{ fontWeight: "bold" }}>
            Back to Home
          </Link>
        </button>
      </div>
    </div>
  );
};

export default Error;
